import { useState, useEffect, useRef, useCallback, Fragment, useMemo } from "react";
import style from "./PotViewItem.module.scss";
import { v4 } from "uuid";
import * as YStyled from "./../../../Styleds";
import allStyle from "./../all.module.scss";
import { CustomEventManager } from "../CustomEventManager";
import ImageLoader from "./ImageLoader";
const customEventManager = new CustomEventManager();
const PotViewItem = ({ pot = {
    "rewilding_id": "66fbf90fbf567bfb6ab729d5",
    "rewilding_area": "南投縣",
    "rewilding_location": [
        "仁愛鄉",
        "南投縣",
        "Taiwan"
    ],
    "rewilding_country_code": "TW",
    "rewilding_name": "這裡是哪裡",
    "rewilding_rating": 0,
    "rewilding_lat": 24.18761574655531,
    "rewilding_lng": 121.20478125,
    "rewilding_place_id": "",
    "rewilding_elevation": 1466.161376953125,
    "rewilding_photos": [
        {
            "rewilding_photos_id": "66fbf90fbf567bfb6ab729d4",
            "rewilding_photos_path": "https://imagedelivery.net/peXbMh4A5r2xX67SaM4zPQ/2cdd4072-ad0d-4697-b133-12a5e8143500/public"
        }
    ],
    "rewilding_reference_links": [
        {
            "rewilding_reference_links_link": "https://hiking.biji.co/index.php?q=review&act=info&review_id=30912",
            "rewilding_reference_links_title": "丹大東郡橫斷(南三段) | 尋找中央山脈深處的童話世界 - 健行筆記",
            "rewilding_reference_links_description": "現代版的南三段，其實不是真正的南三段以路線來說，正確的說法應該是「丹大東郡橫斷」傳統南三段，又稱「大南三段」，是從六順山經關門北峰大小石公到丹大山後接回現今的丹大東郡橫斷「丹大東郡橫斷」被...",
            "rewilding_reference_links_og_title": "丹大東郡橫斷(南三段) | 尋找中央山脈深處的童話世界",
            "rewilding_reference_links_og_description": "現代版的南三段，其實不是真正的南三段以路線來說，正確的說法應該是「丹大東郡橫斷」傳統南三段，又稱「大南三段」，是從六順山經關門北峰大小石公到丹大山後接回現今的丹大東郡橫斷「丹大東郡橫斷」被...",
            "rewilding_reference_links_og_image": "https://cdntwrunning.biji.co/600_b20ec1ca45d6653629b56b6e34a45daa.jpg",
            "rewilding_reference_links_og_site_name": "丹大東郡橫斷(南三段) | 尋找中央山脈深處的童話世界"
        }
    ],
    "rewilding_apply_official": false,
    "rewilding_created_by": "66574916c5f01d3e7982ef94",
    "rewilding_created_at": "2024-10-01T13:28:47.007Z",
    "rewilding_created_by_user": {
        "user_id": "66574916c5f01d3e7982ef94",
        "user_name": "sifumi",
        "user_email": "ulixes6@gmail.com",
        "user_avatar": ""
    }
}, type, onClick }) => {
    useEffect(() => {
        console.log(pot)
    }, [])
    /*  */
    if (type === "rank") {
        return (
            <YStyled.Label style={{ width: "100%" }} onClick={e => { if (onClick) onClick(pot) }}>
                <YStyled.Row gap="1rem" style={{ height: "100%" }}>
                    <ImageLoader src={(pot.rewilding_photos?.length > 0) ? pot.rewilding_photos[0].rewilding_photos_path : ''} style={{ width: "20%", borderRadius: "10px", aspectRatio: "1/1", objectFit: "cover" }} />
                    <YStyled.Col gap=".4rem" style={{ height: "100%" }}>
                        <YStyled.Span size={15}>{pot.rewilding_name}</YStyled.Span>
                        <YStyled.Span size={13}>{pot.rewilding_location ? pot.rewilding_location.join(" ") : ""}</YStyled.Span>
                        <YStyled.Label style={{ background: "#eee", padding: ".4rem .6rem", borderRadius: "5px" }}>
                            <YStyled.Span color="#0000ff" size={11}>{`#${pot.rewilding_type_list?.join(' ')}`}</YStyled.Span>
                        </YStyled.Label>
                    </YStyled.Col>
                </YStyled.Row>
            </YStyled.Label>
        );
    }
    else
        return (
            <div className={style.item} onClick={e => { if (onClick) onClick(pot) }}>
                <YStyled.BackgroundDiv img={(pot.rewilding_photos?.length > 0) ? pot.rewilding_photos[0].rewilding_photos_path : ''} className={style.bg} />
                <div>
                    <div style={{flexGrow:"1"}}>
                        <span>{pot.rewilding_name}</span>
                        <span>{pot.rewilding_location ? pot.rewilding_location.join(" ") : ""}</span>
                    </div>
                    {type === "selPot" &&
                        <YStyled.BTN3 style={{borderRadius:"1rem",alignSelf:"center",padding:"1rem"}} onClick={e=>{
                            e.stopPropagation();
                            customEventManager.dispatch("selPot", pot);
                        }}>
                            <YStyled.Span size={14}>加入</YStyled.Span>
                        </YStyled.BTN3>
                    }
                </div>
            </div>
        );
}

export default PotViewItem;